import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CategoryHOFService } from 'app/_services/category-hof.service';
import { DialogsService } from 'app/_services/dialogs/dialogs.service';
import { NotificationService } from 'app/_services/notification.service';
import { CategoryHOF } from '../category';
import { EditCategoryHOFDialogComponent } from '../edit-categoryHOF-dialog/edit-categoryHOF-dialog.component';

@Component({
    selector: 'app-category-hall-of-fame',
    templateUrl: './category-hall-of-fame.component.html',
    styleUrls: ['../../shared/table-defaults.scss', '../categories.component.scss'],
})
export class CategoryHallOfFameComponent implements OnInit {
    categories: CategoryHOF[];
    categoryNames: string[];
    dataSource: MatTableDataSource<CategoryHOF>;

    displayedColumns: string[] = ['categoryName', 'actions'];
    columnsToDisplay = this.displayedColumns.slice();

    @ViewChild(MatTable) table: MatTable<CategoryHOF[]>;

    constructor(
        private catHOFService: CategoryHOFService,
        public dialog: MatDialog,
        private dialogSerivce: DialogsService,
        private notificationService: NotificationService
    ) {}

    ngOnInit(): void {
        this.catHOFService.getCategories().subscribe((categories) => {
            this.categories = categories;
            this.loadDatasource(this.categories);
            this.categoryNames = this.categories.map((category) => category.categoryName);
        });
    }

    loadDatasource(data: CategoryHOF[]): void {
        this.dataSource = new MatTableDataSource(data);
    }

    newCategory(): CategoryHOF {
        return {
            hofcategoryId: 0, // Set to 0 since this column is set to Identity in database
            categoryName: null,
        };
    }

    openEditCategoryDialog(
        category: CategoryHOF,
        categoryNames: string[],
        title: string
    ): MatDialogRef<EditCategoryHOFDialogComponent> {
        const config: MatDialogConfig = {
            width: '80vw',
            maxWidth: '600px',
            panelClass: 'categoryEditor',
            data: { category, categoryNames, title },
        };

        return this.dialog.open(EditCategoryHOFDialogComponent, config);
    }

    addCategory(): void {
        const categories = this.categories;
        const categoryNames = this.categoryNames;
        const title = 'Add Category';

        const category = this.newCategory();

        const dialogResult = this.openEditCategoryDialog(category, categoryNames, title);

        dialogResult.afterClosed().subscribe((result: CategoryHOF) => {
            if (!result) {
                return;
            }

            this.catHOFService.createCategory(result).subscribe((res) => {
                categories.push(res);
                this.loadDatasource(categories);
                this.notificationService.showSuccess(`Category has been added.`);
            });
        });
    }

    editCategory(category: CategoryHOF): void {
        const categoryNames = this.categoryNames;
        const title = `Edit Category - ${category.categoryName}`;

        const dialogResult = this.openEditCategoryDialog(category, categoryNames, title);

        dialogResult.afterClosed().subscribe((result: CategoryHOF) => {
            if (!result) {
                return;
            }

            this.catHOFService.updateCategory(result.hofcategoryId, result).subscribe();
            this.notificationService.showSuccess(`Category has been updated.`);
        });
    }

    deleteCategory(category: CategoryHOF): void {
        const dialogResult$ = this.dialogSerivce.OpenConfirmationDialog({
            TitleText: `Delete Category - ${category.categoryName}`,
            MessageText: 'Are you sure you want to delete this category?',
            SubMessageText: 'Deleting this category will also remove it from all calendar events and feeds. THIS CANNOT BE UNDONE!',
            OKText: 'Yes, remove category',
            CancelText: 'No',
            DelayDelete: 5, // Number of seconds to delay delete button
        });

        dialogResult$.subscribe((result) => {
            if (!result) {
                return;
            }

            const index = this.dataSource.data.indexOf(category, 0);

            if (index > -1) {
                this.dataSource.data.splice(index, 1);
            }

            this.catHOFService.deleteCategory(category.hofcategoryId).subscribe();
            this.table.renderRows();
            this.notificationService.showSuccess(`Category have been removed.`);
        });
    }
}
